<section id="resume" class="resume">
  <div class="container" data-aos="fade-up">
    <div class="section-title">
      <h2>Resumen</h2>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <h3 class="resume-title">Educación</h3>
        <div class="resume-item">
          <h4>Frontend Developer</h4>
          <h5>2019 - 2021</h5>
          <p>
            Mis estudios dentro de la programación son principalmente de manera
            online en plataformas como Platzi, FreeCodeCamp, Udemy, Google
            Activate (más de 3000 horas de teoría y práctica) (<a
              href="https://diplomas-79a7c.web.app/"
              target="__blank"
              >listado de cursos</a
            >). Pero también aprendí de manera particular con mentores con más
            de 10 años de experiencia. Considero que es un área en la que nunca
            hay que dejar de aprender y estar continuamente capacitandoce.
          </p>
        </div>
        <div class="resume-item">
          <h4>Auxiliar Administrativo Contable.</h4>
          <h5>2016 - 2017</h5>
          <p><em>HILET</em></p>
          <p>Auxiliar Administrativo Contable.</p>
        </div>
        <div class="resume-item">
          <h4>Secundaria.</h4>
          <h5>2006 - 2009</h5>
          <p><em>Colegio Luis Federico Le Loir </em></p>
          <p>Estudios de nivel secundario.</p>
        </div>
        <div class="resume-item">
          <h4>Primaria.</h4>
          <h5>1994 - 2006</h5>
          <p><em>Colegio Evángelico Los Pinares </em></p>
          <p>Estudios de nivel primario.</p>
        </div>
      </div>

      <div class="col-lg-6">
        <h3 class="resume-title">Experiencia Profesional</h3>
        <div class="resume-item">
          <h4>Frontend Web Developer</h4>
          <h5>2021 - Actualidad</h5>
          <p><em>Neoris</em></p>
          <ul>
            <li>Frontend Web Developer</li>
            <li>Angular, NgRx, Scss, Typescript y RxJs</li>
          </ul>
        </div>
        <div class="resume-item">
          <h4>Angular Developer</h4>
          <h5>2021 - 2021</h5>
          <p><em>EY</em></p>
          <ul>
            <li>Proyecto de Interconsultas Sescam</li>
            <li>Angular, NgRx, Scss, Ionic, Typescript y RxJs</li>
          </ul>
        </div>
        <div class="resume-item">
          <h4>Angular Developer</h4>
          <h5>2020 - 2021</h5>
          <p><em>Qubik Digital</em></p>
          <ul>
            <li>Desarrollo de proyectos SAP Ecommerce</li>
            <li>
              Angular, NgRx, Scss, Bootstrap, Spartacus, Typescript y RxJs
            </li>
          </ul>
        </div>
        <div class="resume-item">
          <h4>UI Developer</h4>
          <h5>2019 - 2020</h5>
          <p><em>MultiEnvases</em></p>
          <ul>
            <li>Maquetador Web con Tienda Nube.</li>
            <li>HTML, CSS y Javascript</li>
          </ul>
        </div>
        <div class="resume-item">
          <h4>Ecommerce Manager</h4>
          <h5>2013 - 2019</h5>
          <p><em>MultiEnvases</em></p>
          <ul>
            <li>
              Encargado de los canales de venta online de la empresa. (Venta,
              publicaciones, facturación, con MercadoLibre y Tienda Nube).
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Resume Section -->
